import { render } from "./AppYellowModal.vue?vue&type=template&id=7e667bd4&scoped=true&ts=true"
import script from "./AppYellowModal.vue?vue&type=script&lang=ts"
export * from "./AppYellowModal.vue?vue&type=script&lang=ts"

import "./AppYellowModal.vue?vue&type=style&index=0&id=7e667bd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e667bd4"]])

export default __exports__